import { Injectable } from '@angular/core';
import { StorageProvider } from '../storage/storage';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { LoggerFactory } from '../logger/logger-factory.service';
import { NetworkProvider } from '../network/network';

/**
 * OfflineSync Provider
 *
 * Ce service permet de stocker des requetes en mode hors-ligne et effectuer ses requêtes en mode en ligne.
 */
@Injectable({ providedIn: 'root' })
export class OfflineSyncProvider {
  /**
   * Tableau des requetes à éxecuter
   */
  requests: any[] = [];

  /**
   * Clé de storage pour les requetes hors-ligne
   */
  STORAGE: string = 'offline';

  /**
   * Logger
   */
  private logger: LoggerWrapper;

  /**
   * Constructeur
   *
   * Crée une instance de OfflineSyncProvider.
   *
   * @param {HttpClient} http
   * @param {StorageProvider} storageProvider
   */
  constructor(
    private storageProvider: StorageProvider,
    private networkProvider: NetworkProvider,
    private loggerFactory: LoggerFactory
  ) {
    this.logger = this.loggerFactory.getInstance(this);
  }

  /**
   * Récupération des requetes stokées hors-ligne
   */
  getRequests() {
    return this.storageProvider
      .get(this.STORAGE, false)
      .then((storage_list) => {
        // this.logger.log("getRequests storage_list ");
        // this.logger.log(storage_list);
        if (storage_list == null) storage_list = [];
        return storage_list;
      })
      .catch((err) => {
        this.logger.error(err, `Error during OfflineSyncProvider#getRequests`);
        return [];
      });
  }

  /**
   * Enregistrement des requetes stokées hors-ligne
   *
   * @param {object} requests requetes à enregistrer
   */
  setRequests(requests) {
    return this.storageProvider
      .set(this.STORAGE, requests, false)
      .then((data) => {
        // this.logger.log("success");
        // this.logger.log(data);
        return data;
      })
      .catch((err) => {
        this.logger.error(err, `Error during OfflineSyncProvider#setRequests`);
      });
  }

  /**
   * Vérification si un document est déjà présent (pour les doublons post / put / delete)
   *
   * @param {object} requests tableaux des requetes
   * @param {object} data document
   */
  checkOfflineAddUpdate(storage_list, data) {
    let i = 0;
    for (let request of storage_list) {
      if (request.data.id == data.id) {
        return i;
      }
      i++;
    }
    return -1;
  }

  /**
   * Ajout d'un document dans le storage d'offline-sync
   *
   * @param {string} method methode de la requete (POST/PUT/DELETE)
   * @param {string} url url de la requete
   * @param {object} data parametres de la requete
   * @param {object} headers headers de la requete
   */
  add(method, url, data, headers) {
    this.logger.log('offline sync add');
    let json = {
      method: method,
      url: url,
      data: data,
      headers: headers,
      date: new Date().getTime().toString(),
    };
    //______________________________________
    //|        | POST   | PUT     | DELETE  |
    //|-------------------------------------|
    //| POST   |   X    |    X    |    X    |
    //| PUT    |   X    |    X    |    X    |
    //| DELETE |   X    |    X    |    X    |
    //--------------------------------------

    this.networkProvider.addHistory("Ajout dans la file d'attente : " + method + ' - ' + url);

    return this.getRequests()
      .then((storage_list) => {
        // CAS POST + PUT ou POST / PUT + DELETE
        let index = this.checkOfflineAddUpdate(storage_list, data);
        this.logger.log('checkOfflineAddUpdate : ' + index);
        if ((method == 'PUT' || method == 'DELETE') && index != -1) {
          // CAS POST + PUT
          if (method == 'PUT') storage_list[index].data = data;
          // CAS DELETE
          if (method == 'DELETE') {
            // CAS PUT + DELETE
            if (storage_list[index].method == 'PUT') storage_list[index].method = 'DELETE';
            // CAS POST + DELETE
            if (storage_list[index].method == 'POST') storage_list.splice(index, 1);
          }
        } else {
          // On verifie si la même requete existe déjà
          let doublon_index = storage_list.findIndex((request) => {
            return request.url == url && request.method == method;
          });
          if (doublon_index >= 0) {
            // On écrase le doublon si il existe
            storage_list[doublon_index] = json;
          } else {
            // On écrase le doublon si il existe
            storage_list.push(json);
          }
        }
        return this.storageProvider.set(this.STORAGE, storage_list, false);
      })
      .then((data) => {
        // this.logger.log("success");
        // this.logger.log(data);
      })
      .catch((err) => {
        this.logger.error(err, `Error during OfflineSyncProvider#add`);
      });
  }
}
